import { Modal as ModalBS } from "react-bootstrap";
import style from "./style.module.scss";
import IcX from "../Svg/IcX";

const Title = props => {
  const { children } = props;
  return <h2 className={style.title}>{children}</h2>;
};
const Header = props => {
  const { children } = props;
  return (
    <ModalBS.Header>
      <div className={style.header}>
        <div>{children}</div>
      </div>
    </ModalBS.Header>
  );
};
const Body = props => {
  const { children } = props;
  return <ModalBS.Body>{children}</ModalBS.Body>;
};
const Footer = props => {
  const { children } = props;
  return <ModalBS.Footer>{children}</ModalBS.Footer>;
};

const ModalCustom = props => {
  const { size, children, show, onHide, disableClose } = props;

  return (
    <ModalBS
      className={style.modal}
      size={size}
      show={show}
      onHide={onHide}
      backdrop={!!disableClose ? "static" : "true"}
      {...props}
    >
      {!disableClose && (
        <button type="button" className={style.closeModal} onClick={onHide}>
          <IcX />
        </button>
      )}
      {children}
    </ModalBS>
  );
};

ModalCustom.Title = Title;
ModalCustom.Header = Header;
ModalCustom.Body = Body;
ModalCustom.Footer = Footer;

export default ModalCustom;
